import { WorkoutMinimapContent } from "./WorkoutMinimapContent";

interface WorkoutMinimapProps {
  className?: string;
}

export function WorkoutMinimap(props: WorkoutMinimapProps) {
  return <WorkoutMinimapContent className={props.className} />;
}
